"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var DEFAULT_MAX_RESULTS = 20;
exports.default = legacy_1.action('processFindPeopleResult')(function processFindPeopleResult(resultList, responseMessage, maxResults) {
    if (responseMessage.ResponseClass == 'Success' && responseMessage.ResultSet) {
        maxResults = maxResults ? maxResults : DEFAULT_MAX_RESULTS;
        maxResults =
            responseMessage.ResultSet.length > maxResults
                ? maxResults
                : responseMessage.ResultSet.length;
        var personaTypeSet = [];
        for (var i = 0; i < maxResults; i++) {
            var result = responseMessage.ResultSet[i];
            personaTypeSet.push({
                EmailAddress: result.EmailAddress,
                PersonaId: result.PersonaId,
                ADObjectId: result.ADObjectId,
            });
        }
        resultList.splice.apply(resultList, [0, resultList.length].concat(personaTypeSet));
    }
});
//# sourceMappingURL=processFindPeopleResult.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-common/lib/actions/processFindPeopleResult.js
// module id = 2707
// module chunks = 2 3 4 45 63